export { default } from './option-selector-ds'
export { default as OptionSelectorDS } from './option-selector-ds'
export type { OptionSelectorDSProps } from './option-selector-ds'
